"use client";

import {
  RecruiteeJobOfferDetails,
  fetchJobOfferDetails,
  recruiteeAllowedMimeTypes,
} from "@/ats/recruitee";
import RecruiteeOpenQuestion from "./RecruiteeOpenQuestion";
import { useEffect, useRef, useState } from "react";
import { useFormState } from "react-dom";
import submitRecruiteeForm, {
  RecruiteeFormState,
} from "@/actions/submitRecruiteeForm";
import DisablingSubmit from "@/components/form/DisablingSubmit";
import { applicationSend } from "@/integrations/gtmDatalayerEvents";

export default function RecruiteeForm({
  jobOfferSlug,
  companySlug,
}: {
  jobOfferSlug: string;
  companySlug: string;
}) {
  const [jobOffer, setJobOffer] = useState<
    RecruiteeJobOfferDetails | undefined
  >();
  const formRef = useRef<HTMLFormElement | null>(null);

  const [formState, formAction] = useFormState<RecruiteeFormState>(
    // @ts-ignore
    submitRecruiteeForm.bind(null, { jobOfferSlug, companySlug }),
    { status: "idle" }
  );

  useEffect(() => {
    fetchJobOfferDetails(companySlug, jobOfferSlug).then(setJobOffer);
  }, [companySlug, jobOfferSlug]);

  useEffect(() => {
    if (formState.status === "success") {
      formRef.current?.reset();

      applicationSend(companySlug, jobOfferSlug);
    }
    showMessage();
  }, [formState, companySlug, jobOfferSlug]);

  const [shouldShowMessage, setShouldShowMessage] = useState(true);
  const showMessage = () => {
    setShouldShowMessage(true);
    setTimeout(() => {
      setShouldShowMessage(false);
    }, 5000);
  };

  return (
    <>
      {jobOffer && (
        <form action={formAction} className="recruitee_form" ref={formRef}>
          <input
            type="hidden"
            name="candidate[referrer]"
            value={window.location.hostname}
          />
          <fieldset>
            <div className="form_col w50">
              <label htmlFor="name">
                <span>Naam</span>
                <span aria-label="required">*</span>
              </label>
              <input type="text" name="candidate[name]" id="name" required />
            </div>
            <div className="form_col w50">
              <label htmlFor="email">
                <span>E-mailadres</span>
                <span aria-label="required">*</span>
              </label>
              <input type="email" name="candidate[email]" id="email" required />
            </div>
            {jobOffer.options_phone != "off" && (
              <div className="form_col">
                <label htmlFor="phone">
                  <span>Telefoonnummer</span>
                  {jobOffer.options_phone == "required" && (
                    <span aria-label="required">*</span>
                  )}
                </label>
                <input
                  type="text"
                  name="candidate[phone]"
                  id="phone"
                  required={jobOffer.options_phone == "required"}
                />
              </div>
            )}
            {jobOffer.options_cv != "off" && (
              <div className="form_col w50">
                <label htmlFor="cv">
                  <span>CV</span>
                  {jobOffer.options_cv == "required" && (
                    <span aria-label="required">*</span>
                  )}
                </label>
                <input
                  type="file"
                  name="candidate[cv]"
                  id="cv"
                  required={jobOffer.options_cv == "required"}
                  accept={recruiteeAllowedMimeTypes.join(",")}
                />
              </div>
            )}
            {jobOffer.options_photo != "off" && (
              <div className="form_col w50">
                <label htmlFor="photo">
                  <span>Foto</span>
                  {jobOffer.options_photo == "required" && (
                    <span aria-label="required">*</span>
                  )}
                </label>
                <input
                  type="file"
                  name="candidate[photo]"
                  id="photo"
                  required={jobOffer.options_photo == "required"}
                />
              </div>
            )}
            {jobOffer.options_cover_letter != "off" && (
              <div className="form_col">
                <label htmlFor="cover_letter">
                  <span>Motivatie</span>
                  {jobOffer.options_cover_letter == "required" && (
                    <span aria-label="required">*</span>
                  )}
                </label>
                <textarea
                  name="candidate[cover_letter]"
                  id="cover_letter"
                  required={jobOffer.options_cover_letter == "required"}
                />
              </div>
            )}
            {jobOffer.open_questions.map((q) => (
              <RecruiteeOpenQuestion question={q} key={q.id} />
            ))}

            {shouldShowMessage && formState.status === "success" && (
              <div className="form_col validation_message">
                <p>
                  Uw formulier is succesvol verzonden. Bedankt voor uw
                  inzending!
                </p>
              </div>
            )}
            {shouldShowMessage && formState.status === "error" && (
              <div className="form_col validation_message validation_error">
                <p>Er is iets misgegaan. Probeer het opnieuw.</p>
              </div>
            )}
            <div className="form_col">
              <DisablingSubmit
                label="Verzenden"
                pendingLabel="Aan het verzenden..."
              />
            </div>
          </fieldset>
        </form>
      )}
    </>
  );
}
